import { render, staticRenderFns } from "./agendaCenter.vue?vue&type=template&id=2c490fc1&scoped=true&"
import script from "./agendaCenter.vue?vue&type=script&lang=js&"
export * from "./agendaCenter.vue?vue&type=script&lang=js&"
import style0 from "./agendaCenter.vue?vue&type=style&index=0&id=2c490fc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c490fc1",
  null
  
)

export default component.exports